import React, { Component } from 'react';
import addNote from '../../resources/images/estrategas/tools/add.png'
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import * as Request from '../../service/data-info-chart/requestsUtil';
import { NEW_BUSINESS_NOTE } from '../../utils/constants';


class AddNote extends Component {

  constructor(props) {
    super(props);
    this.toggleModal = this.toggleModal.bind(this);
    this.saveNote = this.saveNote.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = { modal: false, note:'' };
  }

  toggleModal(){
    this.setState({ modal: !this.state.modal });
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  }

  saveNote(){

    let params = {
      businessId: this.props.id,
      note: this.state.note
    };

    Request.postFetch3(NEW_BUSINESS_NOTE, params).then(()=>{
      this.props.callbackFromParent(Math.random());
      this.toggleModal()
    })

  }


  render() {
    let classUser = this.props.authorization ? 'add-notes-icon' : 'quality-edit-unauthorized';
    return (
      <div>
        <Modal isOpen={this.state.modal} toggle={this.toggleModal} className={this.props.className}>
          <ModalHeader className='header-modal' toggle={this.toggleModal}>Agregar nota</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="note">Detalle</Label>
              <Input
                type="textarea"
                name="note"
                id="note"
                value={this.state.note}
                onChange={this.handleChange}
                style={{ height: '150px' }}
                maxLength={500}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveNote}>Guardar</Button>{' '}
            <Button color="danger" onClick={this.toggleModal}>Cancelar</Button>
          </ModalFooter>
        </Modal>
        <div className={classUser} onClick={this.toggleModal}>
          <img src={addNote} title='Agregar nota' alt=''/>
        </div>
      </div>
    );
  }
}

export default AddNote;



// WEBPACK FOOTER //
// ./src/components/buttons/addNoteNewBusiness.js